export default 'subscription'
